import { render, staticRenderFns } from "./MultiColumn.vue?vue&type=template&id=2b5eeaa7&scoped=true"
import script from "./MultiColumn.vue?vue&type=script&lang=js"
export * from "./MultiColumn.vue?vue&type=script&lang=js"
import style0 from "./MultiColumn.vue?vue&type=style&index=0&id=2b5eeaa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5eeaa7",
  null
  
)

export default component.exports